import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Calendar, Briefcase, GraduationCap, Heart, Layers } from 'lucide-react';
import { Button } from './ui/Button';
const audiences = [{
  icon: Layers,
  title: 'DTF Customers',
  description: 'Apparel brands, print shops, teams, and resellers who need fast, consistent DTF transfers shipped nationwide with predictable turnaround.'
}, {
  icon: Briefcase,
  title: 'Businesses',
  description: 'Promote your brand with consistent, professional apparel and printed materials for employees, crews, and customers.'
}, {
  icon: Calendar,
  title: 'Events',
  description: 'Make your event memorable with custom shirts for reunions, birthdays, weddings, races, and more.'
}, {
  icon: GraduationCap,
  title: 'Schools',
  description: 'Show school spirit with custom team shirts, club apparel, uniforms, and spirit wear.'
}, {
  icon: Heart,
  title: 'Fundraising',
  description: 'Raise money for your organization with custom apparel that supporters are proud to wear.'
}];
export function WhoWeAreFor() {
  return <section className="py-20 bg-atomic-black border-t border-white/5" data-id="element-418">
      <div className="container mx-auto px-4 md:px-6" data-id="element-419">
        <div className="max-w-6xl mx-auto" data-id="element-420">
          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-421">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-422">
              Who We're For
            </h2>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-423">
              Print Atomic works with teams, businesses, and organizations
              nationwide — providing fast, reliable custom apparel and shipping
              DTF transfers across the U.S.
            </p>
          </motion.div>

          {/* 5-Column Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 mb-12" data-id="element-424">
            {audiences.map((audience, index) => <motion.div key={audience.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-atomic-charcoal rounded-xl p-6 border border-white/10" data-id="element-425">
                <div className="w-12 h-12 rounded-lg bg-atomic-green/10 flex items-center justify-center text-atomic-green mb-4 border border-atomic-green/20" data-id="element-426">
                  <audience.icon size={24} data-id="element-427" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-428">
                  {audience.title}
                </h3>
                <p className="text-gray-400 leading-relaxed text-sm" data-id="element-429">
                  {audience.description}
                </p>
              </motion.div>)}
          </div>

          {/* Supporting Text */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8" data-id="element-430">
            <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-431">
              From one-off orders to large production runs, we help customers
              solve apparel and visibility challenges with consistent results.
              Our process is built for speed, reliability, and scalable
              production.
            </p>
          </motion.div>

          {/* Soft CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-432">
            <p className="text-gray-400 mb-6" data-id="element-433">
              Have a project in mind? Get a quote and we'll help you choose the
              fastest, most reliable option.
            </p>
            <a href="/contact" data-id="element-434">
              <Button size="lg" data-id="element-435">Get a Quote</Button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}